const setNotificationClose = () => {
  const btn = document.getElementById('notification-close-btn');
  if (!btn) return false;

  btn.addEventListener('click', () => {
    btn.closest('.notification').classList.add('is-hide')
  })
};

export default setNotificationClose;
